import cn from 'classnames';
// Types
import { GetNotReviewedAnyAiClipCandidates_getNotReviewedAnyAiClipCandidates } from 'api/interview/types/GetNotReviewedAnyAiClipCandidates';
// Helpers
import { getAiClipTitle } from 'helpers/aiClips';
// Ui
import Button from 'ui3/Button/Button';
// Styles
import styles from './AiClipCandidateCard.module.scss';

type AiClipCandidateCardProps = {
  index: number;
  candidate: GetNotReviewedAnyAiClipCandidates_getNotReviewedAnyAiClipCandidates;
  setReviewModalVisibility: (
    candidate: GetNotReviewedAnyAiClipCandidates_getNotReviewedAnyAiClipCandidates,
    index: number
  ) => void;
  compact?: boolean;
};

const AiClipCandidateCard = ({
  index,
  candidate,
  compact = false,
  setReviewModalVisibility,
}: AiClipCandidateCardProps) => {
  const handleReviewModalOpen = () => {
    setReviewModalVisibility(candidate, index);
  };

  const topic = candidate.topic?.trim();

  return (
    <div className={cn(styles.root, { [styles.rootCompact]: compact })}>
      <div className={styles.infoWrapper}>
        <p className={cn(styles.title, styles.large)}>AI Clip #{index}</p>

        <div className={styles.dataSection}>
          <p className={styles.data}>
            Title:
            <span className={styles.dataValue}>
              {getAiClipTitle(candidate, index)}
            </span>
          </p>
          {topic && (
            <p className={styles.data}>
              Topic:
              <span className={styles.dataValue}>{topic}</span>
            </p>
          )}
        </div>

        <div className={styles.buttonWrapper}>
          <Button
            size="medium"
            variant="secondary"
            onClick={handleReviewModalOpen}
            className={styles.reviewMediaPostButton}
          >
            Review
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AiClipCandidateCard;
